import client from './client'
import type {
  CockpitKpis,
  CockpitFinancials,
  CockpitLeaderboardEntry,
  CockpitActivityItem,
  CockpitOps,
  TimeRange,
  FinancialBucket,
  ActivityType,
} from '@/types/cockpit'

// ---- Params helpers --------------------------------------------------------

function timeRangeParams(range: TimeRange): Record<string, string | undefined> {
  if (range.key === 'custom') {
    return { range: 'custom', from: range.from, to: range.to }
  }
  return { range: range.key }
}

// ---- KPIs ------------------------------------------------------------------

export async function fetchCockpitKpis(range: TimeRange): Promise<CockpitKpis> {
  const { data } = await client.get<{ data: CockpitKpis }>('/admin/cockpit/kpis', {
    params: timeRangeParams(range),
  })
  return data.data
}

// ---- Financials ------------------------------------------------------------

export async function fetchCockpitFinancials(
  range: TimeRange,
  bucket: FinancialBucket,
): Promise<CockpitFinancials> {
  const { data } = await client.get<{ data: CockpitFinancials }>('/admin/cockpit/financials', {
    params: { ...timeRangeParams(range), bucket },
  })
  return data.data
}

// ---- Leaderboard -----------------------------------------------------------

export async function fetchCockpitLeaderboard(
  range: TimeRange,
  limit?: number,
): Promise<CockpitLeaderboardEntry[]> {
  const { data } = await client.get<{ data: CockpitLeaderboardEntry[] }>(
    '/admin/cockpit/leaderboard',
    { params: { ...timeRangeParams(range), limit } },
  )
  return data.data
}

// ---- Activity feed ---------------------------------------------------------

export interface ActivityParams {
  cursor?: string | null
  type?: ActivityType | null
  limit?: number
}

export interface ActivityResponse {
  data: CockpitActivityItem[]
  meta: { next_cursor: string | null }
}

export async function fetchCockpitActivity(params: ActivityParams): Promise<ActivityResponse> {
  const { data } = await client.get<ActivityResponse>('/admin/cockpit/activity', {
    params: {
      cursor: params.cursor ?? undefined,
      type: params.type ?? undefined,
      limit: params.limit,
    },
  })
  return data
}

// ---- Ops -------------------------------------------------------------------

export async function fetchCockpitOps(): Promise<CockpitOps> {
  const { data } = await client.get<{ data: CockpitOps }>('/admin/cockpit/ops')
  return data.data
}
